import { FieldArray, Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Table } from "react-bootstrap";
import {
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
} from "../../../../../partials/content/Forms/FormField";
import { DialogActions, InputAdornment } from "@material-ui/core";
import Illustration from "../../../../../partials/content/Illustration";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchWarehouse from "../../../inventory/warehouses/searchWarehouse";
import { saveJourneyStocks } from "../../../../../services/crm/salesJourney";
import Swal from "sweetalert2";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import SearchItem from "../../../inventory/items/searchItem";
import SearchItemUom from "../../../inventory/items/searchItemUom";
import { isMobile } from "react-device-detect";
const stocksSchema = yup.object().shape({
  data: yup
    .array()
    .of(
      yup.object().shape({
        ID: yup.number(),
        journeyID: yup.number(),
        warehouseID: yup.number(),
        warehouseName: yup.string().required("Warehouse is required"),
        itemID: yup.number(),
        itemName: yup.string().required("Item Name is required"),
        varCode: yup.string(),
        qty: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Quantity is required")
          .min(1, "Quantity cannot be zero or empty")
          .default(0),
        uomID: yup.number(),
        uomName: yup.string().required("Unit is required"),
      })
    )
    .required("Stock Request cannot be empty"),
});

const JourneyStocksForm = ({
  stock,
  journeyID,
  onConfirmSave,
  onCloseStocksForm,
}) => {
  const [openSearchItem, setOpenSearchItem] = useState(false);
  const [tab, setTab] = useState({
    ID: 1,
    title: "Sellable Items",
    icon: "fas fa-boxes",
  });
  const [openSearchUom, setOpenSearchUom] = useState(false);
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(false);
  const [itemIndex, setItemIndex] = useState(0);
  const [stocks, setStocks] = useState({
    data: isMobile
      ? [
          {
            ID: 0,
            journeyID,
            warehouseID: 0,
            warehouseName: "",
            itemID: 0,
            itemType: "",
            itemTypeName: "",
            itemCode: "",
            itemName: "",
            varCode: "",
            qty: 0,
            uomID: 0,
            uomName: "",
          },
        ]
      : [],
  });
  useEffect(() => {}, []);
  return (
    <React.Fragment>
      <Formik
        initialValues={stocks}
        enableReinitialize={true}
        validateOnChange={false}
        validationSchema={stocksSchema}
        onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
          values.data.forEach((value) => {
            value.qty = parseFloat(value.qty);
          });
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Journey Stock ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveJourneyStocks(values.data).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  onConfirmSave();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        {({
          values,
          status,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <form
            autoComplete="off"
            className="kt-form"
            onSubmit={handleSubmit}
            onKeyDown={onPreventEnterSubmitting}
          >
            <FieldArray name="data">
              {({ push, remove }) => (
                <React.Fragment>
                  {isMobile ? (
                    <React.Fragment>
                      <h5>Item Name</h5>
                      <FormArrayTextField
                        index={0}
                        arrayPropName="data"
                        propName="itemName"
                        margin="none"
                        searchButton
                        readonly
                        onSearchClick={() => {
                          setOpenSearchItem(true);
                        }}
                      />
                      <br />
                      <br />
                      <h5>Warehouse</h5>
                      <FormArrayTextField
                        index={0}
                        arrayPropName="data"
                        propName="warehouseName"
                        margin="none"
                        searchButton
                        readonly
                        onSearchClick={() => {
                          setItemIndex(0);
                          setOpenSearchWarehouse(true);
                        }}
                      />
                      <br />
                      <br />
                      <h5>Qty</h5>
                      <FormArrayTextField
                        index={0}
                        arrayPropName="data"
                        propName="qty"
                        quantityField
                        margin="none"
                      />
                      <br />
                      <br />
                      <h5>Uom</h5>
                      <FormArrayTextField
                        index={0}
                        arrayPropName="data"
                        propName="uomName"
                        margin="none"
                        searchButton
                        readonly
                        onSearchClick={() => {
                          setItemIndex(0);
                          setOpenSearchUom(true);
                        }}
                      />
                    </React.Fragment>
                  ) : (
                    <div className="row mb-3">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="card">
                          <Table borderless size="sm" responsive="xl">
                            {values.data && values.data.length > 0 ? (
                              <thead className="text-center">
                                <tr>
                                  <th style={{ width: "35%" }}>Item Name</th>
                                  <th style={{ width: "35%" }}>Warehouse</th>
                                  <th style={{ width: "10%" }}>Quantity</th>
                                  <th style={{ width: "15%" }}>Unit</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                            ) : null}
                            <tbody>
                              {values.data && values.data.length > 0 ? (
                                values.data.map((item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <FormOutlinedNoMarginTextField
                                        value={`${item.itemCode} ${item.itemName}`}
                                        InputProps={{
                                          startAdornment:
                                            item.itemType > 0 ? (
                                              <InputAdornment position="start">
                                                <BootstrapTooltip
                                                  title={item.itemTypeName}
                                                >
                                                  <i
                                                    className={
                                                      item.itemType === 1
                                                        ? "fas fa-boxes text-success"
                                                        : item.itemType === 2
                                                        ? "fas fa-tools text-primary"
                                                        : item.itemType === 3
                                                        ? "fas fa-building text-info"
                                                        : item.itemType === 4
                                                        ? "fas fa-boxes text-warning"
                                                        : item.itemType === 5
                                                        ? "fas fa-boxes text-danger"
                                                        : null
                                                    }
                                                  ></i>
                                                </BootstrapTooltip>
                                              </InputAdornment>
                                            ) : null,
                                          readOnly: true,
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <FormArrayTextField
                                        index={index}
                                        arrayPropName="data"
                                        propName="warehouseName"
                                        margin="none"
                                        searchButton
                                        readonly
                                        onSearchClick={() => {
                                          setItemIndex(index);
                                          setOpenSearchWarehouse(true);
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <FormArrayTextField
                                        index={index}
                                        arrayPropName="data"
                                        propName="qty"
                                        quantityField
                                        margin="none"
                                      />
                                    </td>
                                    <td>
                                      <FormArrayTextField
                                        index={index}
                                        arrayPropName="data"
                                        propName="uomName"
                                        margin="none"
                                        searchButton
                                        readonly
                                        onSearchClick={() => {
                                          setItemIndex(index);
                                          setOpenSearchUom(true);
                                        }}
                                      />
                                    </td>
                                    <td
                                      style={{ whiteSpace: "nowrap" }}
                                      className="text-center"
                                    >
                                      <BootstrapTooltip title="Delete Request Item">
                                        <button
                                          type="button"
                                          className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                          onClick={() => {
                                            setItemIndex(0);
                                            remove(index);
                                          }}
                                        >
                                          <i className="fas fa-trash-alt"></i>
                                        </button>
                                      </BootstrapTooltip>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="text-center py-3" colSpan="5">
                                    <Illustration
                                      imageSource="INVIFO Inventory.png"
                                      guidance="You don't have any Request items yet"
                                      guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                      size="sm"
                                    ></Illustration>
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td className="text-center py-3" colSpan="5">
                                  <button
                                    type="button"
                                    className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                    onClick={() => {
                                      setOpenSearchItem(true);
                                    }}
                                  >
                                    <i className="fas fa-plus-circle"></i>
                                    Add Request Item
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  )}

                  <DialogLayout
                    open={openSearchItem}
                    title="Search Item"
                    onCloseDialog={() => {
                      setOpenSearchItem(false);
                    }}
                    minHeight={true}
                  >
                    <SearchItem
                      tab={tab}
                      selectSellableItems={true}
                      selectServiceItems={false}
                      selectItemPackages={false}
                      selectAssetItems={false}
                      selectVariant={true}
                      onSelectItem={(item, itemPackage, varCode, valueName) => {
                        if (isMobile) {
                          const data = [...values.data];
                          data[0].itemID = item.ID;
                          data[0].itemType = item.itemType;
                          data[0].itemTypeName = item.itemTypeName;
                          data[0].itemCode = item.itemCode;
                          data[0].itemName = item.itemName + " " + valueName;
                          data[0].varCode = varCode;
                          data[0].uomID = item.uomID;
                          data[0].uomName = item.itemUom.uomName;
                          setFieldValue("data", data);
                        } else {
                          push({
                            ID: 0,
                            journeyID,
                            warehouseID: 0,
                            warehouseName: "",
                            itemID: item.ID,
                            itemType: item.itemType,
                            itemTypeName: item.itemTypeName,
                            itemCode: item.itemCode,
                            itemName: item.itemName + " " + valueName,
                            varCode: varCode,
                            qty: 0,
                            uomID: item.uomID,
                            uomName: item.itemUom.uomName,
                          });
                        }

                        setOpenSearchItem(false);
                      }}
                    />
                    <DialogActions>
                      <button
                        type="button"
                        className="btn btn-label-danger btn-md btn-pill btn-bold"
                        onClick={() => {
                          setOpenSearchItem(false);
                        }}
                      >
                        <i className="fas fa-window-close"></i>
                        Close
                      </button>
                    </DialogActions>
                  </DialogLayout>
                </React.Fragment>
              )}
            </FieldArray>

            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={onCloseStocksForm}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            </DialogActions>
            <DialogLayout
              open={openSearchWarehouse}
              title="Search Warehouse"
              onCloseDialog={handleCloseSearchWarehouse}
              maxWIdth="md"
            >
              <SearchWarehouse
                onSelectWarehouse={(warehouse) => {
                  setFieldValue(
                    "data[" + itemIndex + "].warehouseID",
                    warehouse.ID
                  );
                  setFieldValue(
                    "data[" + itemIndex + "].warehouseName",
                    warehouse.warehouseName
                  );
                  handleCloseSearchWarehouse();
                }}
              />
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={handleCloseSearchWarehouse}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
              </DialogActions>
            </DialogLayout>
            <DialogLayout
              open={openSearchUom}
              title="Search Unit of Measurement"
              onCloseDialog={() => {
                setOpenSearchUom(false);
              }}
              maxWIdth="sm"
            >
              {values.data[itemIndex] && values.data[itemIndex].itemID > 0 ? (
                <SearchItemUom
                  itemID={values.data[itemIndex].itemID}
                  onSelectUom={(uom) => {
                    setFieldValue(`data[${itemIndex}].uomID`, uom.ID);
                    setFieldValue(`data[${itemIndex}].uomName`, uom.uomName);
                    setOpenSearchUom(false);
                  }}
                />
              ) : null}
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={() => {
                    setOpenSearchUom(false);
                  }}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
              </DialogActions>
            </DialogLayout>
          </form>
        )}
      </Formik>
    </React.Fragment>
  );

  function handleCloseSearchWarehouse() {
    setOpenSearchWarehouse(false);
  }
};

export default JourneyStocksForm;
